/**
 * Entidade de Domínio: Task
 * Representa uma tarefa relacionada a um lead
 */

export class Task {
    constructor(
        public readonly id: string,
        public readonly leadId: string | null | undefined, // Agora opcional - tarefa pode ou não estar vinculada a uma negociação
        private title: string,
        private dueDate: Date,
        private isCompleted: boolean = false,
        public description: string = '',
        public type: string = '',
        public readonly assignedTo?: string,
        public readonly createdAt: Date = new Date()
    ) {
        this.validate();
    }

    private validate(): void {
        if (!this.title || this.title.trim().length < 3) {
            throw new Error('Título da tarefa deve ter pelo menos 3 caracteres');
        }

        // leadId é opcional - tarefa pode existir sem negociação vinculada

        // Permite data de hoje
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        if (this.dueDate < today) {
            // throw new Error('Data de vencimento não pode ser no passado');
            // Comentado para permitir tarefas atrasadas na importação/criação se necessário
        }
    }

    // Getters
    getTitle(): string {
        return this.title;
    }

    getDueDate(): Date {
        return this.dueDate;
    }

    getIsCompleted(): boolean {
        return this.isCompleted;
    }

    getDescription(): string {
        return this.description;
    }

    getType(): string {
        return this.type;
    }

    // Métodos de negócio
    updateTitle(newTitle: string): void {
        if (!newTitle || newTitle.trim().length < 3) {
            throw new Error('Título da tarefa deve ter pelo menos 3 caracteres');
        }
        this.title = newTitle;
    }

    updateDescription(newDescription: string): void {
        this.description = newDescription;
    }

    updateDueDate(newDate: Date): void {
        // const today = new Date();
        // today.setHours(0, 0, 0, 0);
        // if (newDate < today) {
        //     throw new Error('Data de vencimento não pode ser no passado');
        // }
        this.dueDate = newDate;
    }

    complete(): void {
        if (this.isCompleted) {
            throw new Error('Tarefa já está completa');
        }
        this.isCompleted = true;
    }

    uncomplete(): void {
        if (!this.isCompleted) {
            throw new Error('Tarefa já está incompleta');
        }
        this.isCompleted = false;
    }

    toggle(): void {
        this.isCompleted = !this.isCompleted;
    }

    // Regras de negócio
    isOverdue(): boolean {
        if (this.isCompleted) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const due = new Date(this.dueDate);
        due.setHours(0, 0, 0, 0);
        return due.getTime() < today.getTime();
    }

    isDueToday(): boolean {
        if (this.isCompleted) return false;
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const due = new Date(this.dueDate);
        due.setHours(0, 0, 0, 0);
        return due.getTime() === today.getTime();
    }

    isDueSoon(): boolean {
        if (this.isCompleted) return false;
        const today = new Date();
        const threeDaysFromNow = new Date(today.getTime() + (3 * 24 * 60 * 60 * 1000));
        return this.dueDate <= threeDaysFromNow && this.dueDate > today;
    }

    daysUntilDue(): number {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const due = new Date(this.dueDate);
        due.setHours(0, 0, 0, 0);
        const diff = due.getTime() - today.getTime();
        return Math.ceil(diff / (1000 * 60 * 60 * 24));
    }

    getPriority(): 'high' | 'medium' | 'low' {
        if (this.isOverdue()) return 'high';
        if (this.isDueToday()) return 'high';
        if (this.isDueSoon()) return 'medium';
        return 'low';
    }
}
